import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const expensesSpendTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "expenses.spend-trend",
  name: "Expense trend",
  description: "Expense trend across the selected period.",
  apps: [
    "home",
    "expenses",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "expenses.records",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "amount_total",
          as: "value",
        },
      ],
    },
    graphQueries: [
      {
        name: "Expenses",
        query: {
          version: 1,
          source: "expenses.records",
          ...period(30),
          select: [
            {
              type: "field",
              field: "expense_date",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "sum",
              field: "amount_total",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "expense_date",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#d63939",
        lineWidth: 2,
        fillOpacity: 0.16,
        valueMultiplier: 1,
      },
    ],
  },
  inputs: {
    title: "Expense trend",
    valueFormat: "currency",
    valueMultiplier: 1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "$36,480",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
